/*
 * @Description: 
 */
import Axios from './config'

const get = (url, params, config={})=> {
    console.log('config',config)
    let defaultConfig = {
        url,
        method: "get",
        params
    }
    return Axios({...defaultConfig, ...config}).then(res=> {
        return res;
    }, err=> {
        return err;
    })
}

const post = (url, data, config={})=> {
    let defaultConfig = {
        url,
        method: "post",
        data
    }
    return Axios({...defaultConfig, ...config}).then(res=> {
        return res;
    }, err=> {
        return err;
    })
}


const put = (url, data, config={})=> {
    let defaultConfig = {
        url,
        method: "put",
        data
    }
    return Axios({...defaultConfig, ...config}).then(res=> {
        return res;
    }, err=> {
        return err;
    })
}

const del = (url, data, config={})=> {
    let defaultConfig = {
        url,
        method: "delete",
        data
    }
    return Axios({...defaultConfig, ...config}).then(res=> {
        return res;
    }, err=> {
        return err;
    })
}

export const install = (Vue, config={})=> {
    Vue.prototype._get = get
    Vue.prototype._post = post
    Vue.prototype._put = put
    Vue.prototype._del = del
}